class FormulasCtrl {
  constructor(SchemaService, FEService, TBService, EventService, TemplateService, AuthService, $scope, $window, $element, $compile) {
    'ngInject';
    Object.assign(this, {$scope, $window, $element, $compile})
    this.ss = SchemaService;
    this.fe = FEService;
    this.tb = TBService;
    this.as = AuthService;
    this.ts = TemplateService;
    this.es = EventService;

    this.newField = {};
    this.PROVIDER = {};
    this.messages = [];
    this.prefills = [];
    this.sourceKeyFields = [];
    this.createdFieldUrl = "";
    this.createdFieldName = "";
    this.selectedTableName = '';
    this.loading = true;
    this.showForm = false;
    this.forcePdfDownload = false;
  }

  async $onInit() {
    let allDbs = [];
    try {
      [allDbs, this.PROVIDER] = await Promise.all([
        this.ss.getGrantedDBs(),        
        this.as.getProviderSettings(),
        this.ts.getTemplateData(),
        this.fe.watchForBinding('action', this.$scope),
      ]);
      this.tables = allDbs.filter(db => db.appId === this.ts.template.appId && !!db.tableName);
      this.initAction(this.action);
      
    } catch (error) {
      this.handleMessage({error, when: "During Page Setup"});
    }
    this.conditionalRequire = this.action=='update' && this.ts.template.references.some(r => r.allowSubmitOnUpdate);
    this.loading = false;
  }
  
  initAction(action){
    const capAction = action.charAt(0).toUpperCase() + action.slice(1);
    this.newField.action = action;
    this.newField.label = `${capAction} ${this.ts.template.title}`;
    this.newField.fieldMap = {};
    this.newField.tableId = '';
  }
  
  resetSourceTable() {
    this.prefills = [];
    this.sourceSchema = {};
    this.sourceKeyFields = [];
  }
  
  async tableSelected(tableId) {
    try {
      const msg = "Changing the Table will reset Prefill Values. Are you sure?";
      if(this.prefills.length && !this.$window.confirm(msg)) return;
      this.newField.tableId = tableId;
      this.resetSourceTable();
      this.sourceSchema = await this.ss.getSchema(this.ts.template, tableId);
      this.sourceKeyFields = this.sourceSchema.fields.filter(f => f.isForeignKey || f.isPrimaryKey);
      if (this.tableOnly) return;
      this.setPrimaryKey(tableId);
    } catch (error) {
      this.handleMessage({error, when: "Loading Table Information"});
    }
  }
  
  async add(newField) {
    const msg = `Adding Formula Links will prevent the addition and removal of Target Tables. \nContinue?`;
    const willPublish = !this.ts.template.published;
    if (willPublish && !this.$window.confirm(msg)) return;
    
    try {
      this.loading = true;
      this.messages = []; //clear previous errors/warning
      
      if (this.prefills.length) {
        newField.fieldMap = this.applyPrefills(newField.fieldMap);
      }
      
      const res = await this.tb.addTemplateFieldLink(newField);
      const { messages, "newLink": { label, publicUrl } } = res.data;

      willPublish && this.ts.notifyUpdate(["published"], { template: { published: true }}, true);

      messages.forEach( msg => this.handleMessage(msg));
      this.createdFieldName = label;
      this.createdFieldUrl = publicUrl;
      
    } catch (error) {
      this.handleMessage({error, when: "When Creating the new Field"});
    }
    
    this.loading = false;
  }
  
  applyPrefills(fieldMap = {}) {
    return this.ts.references.reduce((acc, r) => {
      const prefills = this.prefills
        .filter(p => p.reference.id === r.id)
        .map(({targetField, sourceField}) => ({targetField, sourceField}));
        
      return prefills.length ? {...acc, [r.id]: { ...acc[r.id], prefills }} : acc;
    }, fieldMap);
  }
  
  setPrimaryKey(tableId){ //if there is 1 reference of chosen table, populate pKey
    const primaryRefs = this.ts.references.filter(ref => ref.tableId === tableId);
    if (primaryRefs.length !== 1) return;
    const recordIdField = this.sourceSchema?.fields.find(f => !!f.isPrimaryKey);
    if (recordIdField) this.newField.fieldMap[primaryRefs[0].id] = {recordIdField};
  }
  
  handleMessage(rawMessage) {
    this.messages = this.fe.updateMessages(this.messages, rawMessage);
    if (rawMessage.error) console.error(rawMessage.error);
  }
  
  cancel() {
    this.onCancel();
  }
  
}

export default {
  bindings: {
    action: "<",
    onCancel: "&"
  },
  templateUrl: "form-builder/build-wizard/formulas/formulas.component.html",
  controller: FormulasCtrl
};
